import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GuestConfirmation } from "./screens/guest/GuestConfirmation";
import { Login } from "./screens/login/LoginScreen";
import { ProtectedRoute } from "./screens/login/ProtectedRoute";
import { AdminPanel } from "./screens/admin/AdminPanel";
import { MainScreen } from "./screens/main-screen/MainScreen";
import "./App.css";
import { GuestProvider } from "./contexts/GuestContext";
import { QrGuestScanScreen } from "./screens/main-screen/admin/admin-scan-qr/QRGuestScanScreen";
import { GuestList } from "./screens/admin/guest-list/GuestList";
import { Guestbook } from "./components/reel-section/guestbook-section/Guestbook";
function App() {
  return (
    <GuestProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainScreen />} />
          <Route path="/confirmation" element={<GuestConfirmation />} />
          <Route path="/admin/login" element={<Login />} />

          <Route
            path="/admin/scan"
            element={
              <ProtectedRoute>
                <QrGuestScanScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/panel"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/guest-list"
            element={
              <ProtectedRoute>
                <GuestList />
              </ProtectedRoute>
            }
          />
          <Route path="/firma" element={<Guestbook />} />
        </Routes>
      </BrowserRouter>
    </GuestProvider>
  );
}

export default App;
